module.exports = __webpack_public_path__ + "img/try_2.d17abe33.png";